export enum LocalStorageKey {
  AG_GRID_VIEW_SETTINGS_LOCAL_STORAGE_NAME_PREFIX = 'ag-grid-view-settings-',
  OVERRIDE_CURRENT_APP_ROLE = 'override-current-app-role',
}
